import { createAxiosClient } from "./axiosFactory";

const axiosClient = createAxiosClient({
  contentType: "application/json",
  authMode: "required",
  withCredentials: true,
  on401: "redirect",
});

export default axiosClient;
